import { boolean, fallback } from "valibot"

export const AntiAliasSchema = fallback(boolean(), false)
